'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/chart.js/src/charts/Chart.Bar.js
// module id = ../../../../chart.js/src/charts/Chart.Bar.js
// module chunks = 5